/*
  Yulan v4g - articles du blog « Guides » : données de la boutique lues en direct.
  - <span data-yulan-prix="handle" [data-yulan-variante="5 boosters"]>32,00 €</span> : prix actuel de la fiche (ou de la variante).
  - <span data-yulan-dispo="handle">Sur la boutique :</span> : « Disponible sur la boutique : » ou « Épuisé pour le moment : ».
  - <a data-yulan-article="handle">texte</a> (sans href) : lien activé dès que l'article cible est publié.
  - Filet de sécurité : un lien /blogs/actualites/… qui mène à une page introuvable redevient du texte simple.
  Sans JavaScript, le texte du relevé reste affiché tel quel (amélioration progressive).
*/
(function () {
  'use strict';
  var root = document.querySelector('.article-template') || document.querySelector('main') || document.body;
  if (!root || !window.fetch) return;
  var cache = {};
  function produit(h) {
    if (!cache[h]) cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    return cache[h];
  }
  function euros(cents) {
    var s = (cents / 100).toFixed(2).replace('.', ',');
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €';
  }
  Array.prototype.forEach.call(root.querySelectorAll('[data-yulan-prix]'), function (el) {
    produit(el.getAttribute('data-yulan-prix')).then(function (p) {
      if (!p || !p.variants || !p.variants.length) return;
      var vt = el.getAttribute('data-yulan-variante');
      var v = vt ? p.variants.filter(function (x) { return x.title === vt; })[0] : p.variants[0];
      if (v) el.textContent = euros(v.price);
    });
  });
  Array.prototype.forEach.call(root.querySelectorAll('[data-yulan-dispo]'), function (el) {
    produit(el.getAttribute('data-yulan-dispo')).then(function (p) {
      if (!p) return;
      el.textContent = p.available ? 'Disponible sur la boutique :' : 'Épuisé pour le moment (alerte de retour en stock sur la fiche) :';
      el.classList.add(p.available ? 'yv-dispo--oui' : 'yv-dispo--non');
    });
  });
  // Comparaison des langues : <span data-yulan-cote="mewtwo-ex-rocket-sar:cn">118,29 €</span> et
  // <p data-yulan-releve="mewtwo-ex-rocket-sar">…</p>, alimentés par le métachamp boutique yulan.comparaisons (mis à jour chaque lundi),
  // imprimé par le modèle d'article dans <script type="application/json" id="yulan-comparaisons">.
  var cmpEl = document.getElementById('yulan-comparaisons');
  if (cmpEl) {
    try {
      var cmp = JSON.parse(cmpEl.textContent || 'null');
      if (cmp && cmp.cartes) {
        var mois = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
        var d = String(cmp.releve || '').split('-');
        var date = d.length === 3 ? (+d[2]) + (d[2] === '01' ? 'er' : '') + ' ' + mois[+d[1] - 1] + ' ' + d[0] : '';
        Array.prototype.forEach.call(root.querySelectorAll('[data-yulan-cote]'), function (el) {
          var k = el.getAttribute('data-yulan-cote').split(':'), c = cmp.cartes[k[0]];
          var v = c && c[k[1]] && c[k[1]][k[2] || 'avg7'];
          if (typeof v === 'number') el.textContent = euros(Math.round(v * 100));
        });
        if (date) Array.prototype.forEach.call(root.querySelectorAll('[data-yulan-releve]'), function (el) {
          el.textContent = 'Cotes relevées le ' + date + ' (moyenne sur 7 jours, guide de prix Cardmarket).';
        });
      }
    } catch (e) { /* données absentes : on garde le relevé imprimé dans l'article */ }
  }
  function existe(url) {
    return fetch(url, { method: 'HEAD', credentials: 'same-origin' }).then(function (r) { return r.ok; }).catch(function () { return true; });
  }
  Array.prototype.forEach.call(root.querySelectorAll('a[data-yulan-article]'), function (a) {
    var url = '/blogs/actualites/' + a.getAttribute('data-yulan-article') + (a.getAttribute('data-yulan-ancre') || '');
    existe(url.split('#')[0]).then(function (ok) { if (ok) a.setAttribute('href', url); });
  });
  Array.prototype.forEach.call(root.querySelectorAll('.article-template__content a[href^="/blogs/actualites/"]'), function (a) {
    existe(a.getAttribute('href').split('#')[0]).then(function (ok) {
      if (!ok) { a.removeAttribute('href'); a.classList.add('yv-lien-attente'); }
    });
  });
})();
